import { render } from "./PowerModeToggle.vue?vue&type=template&id=7b67d487"
import script from "./PowerModeToggle.vue?vue&type=script&lang=js"
export * from "./PowerModeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__